// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__18Z3j","right":"Footer_right__HnIXy","buttons":"Footer_buttons__1TVIv"};